/**
 * Playful phrases displayed while an AI agent is preparing a
 * response but hasn't streamed anything visible yet. Shared between
 * the legacy chat thread (`ai/chat/components/chat-thread.tsx`) and
 * the new Ask Redo conversation
 * (`merchant/app/.../ask-redo/components/ask-redo-conversation.tsx`)
 * so the two surfaces don't drift on tone.
 */
export const AI_THINKING_PHRASES = [
  "Thinking",
  "Pondering",
  "Brewing",
  "Conjuring",
  "Crafting",
  "Cooking",
  "Summoning",
  "Scheming",
  "Dreaming",
  "Manifesting",
  "Imagining",
  "Calculating",
  "Contemplating",
  "Brainstorming",
  "Percolating",
  "Marinating",
  "Concocting",
  "Whipping up",
  "Spinning up",
  "Crunching",
] as const;
